import React, { useEffect } from 'react';

import { useProcurement } from '../context/ProcurementContext';

import CoverageBar from './CoverageBar';
import CoverageByDepartment from './CoverageByDepartment';
import KpiFlow from './KpiFlow';
import PipelineBoard from './PipelineBoard';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

import useApiRequest from 'Hooks/useApiRequest';
import { useCustomEvent } from 'Hooks/useGlobalDOMEvents';

/**
 * IB-699 — Procurement Overview. Reads the precomputed procurement_stats row (extended
 * with coverage figures + breakdowns) and renders the pipeline board, KPI flow, coverage
 * bar and coverage-by-department. Currency is threaded from the budget's symbol.
 */
const OverviewTab = () => {
    const { settings, routes } = useProcurement();
    const currencySymbol = settings.currencySymbol;

    const { data: stats, get: fetchStats, loading } = useApiRequest({ url: routes.fetchProcurementStatsUrl });

    useCustomEvent({
        eventName: 'REFETCH_PROCUREMENT_DASHBOARD',
        onSignal: () => fetchStats(),
    });

    useEffect(() => {
        fetchStats();
    }, []);

    if (loading && !stats) {
        return (
            <div className="tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-6 tw-py-6.5">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div className="tw-flex tw-flex-col tw-gap-6">
            <PipelineBoard stats={stats} currencySymbol={currencySymbol} />
            <KpiFlow stats={stats} currencySymbol={currencySymbol} />
            <CoverageBar stats={stats} currencySymbol={currencySymbol} />
            <CoverageByDepartment stats={stats} currencySymbol={currencySymbol} />
        </div>
    );
};

export default OverviewTab;
